// extracted by mini-css-extract-plugin
export var loadingSpinner = "LoadingSpinner-module--loading-spinner--idh1z";
export var ldsEllipsis1 = "LoadingSpinner-module--lds-ellipsis1--10ESz";
export var ldsEllipsis2 = "LoadingSpinner-module--lds-ellipsis2--ckd5m";
export var ldsEllipsis3 = "LoadingSpinner-module--lds-ellipsis3--2pMkM";